<template>
  <div class="com-box" v-if="attentionMsg">
    <div class="com-title-box">
      <img src="@/assets/icons/icon-ys@2x.png" alt="" />
      <span>{{attentionTitle}}</span>
      <img src="@/assets/icons/icon-ys@2x.png" alt="" />
    </div>
    <div class="com-content" v-html="attentionMsg"></div>
  </div>
  <div class="card" v-else>
    <div class="card-title">注意事项</div>
    <div class="card-content">
      1. 策划方案主题鲜明且统一贯穿。<br/>
      2. 方案的执行要给地方办事处充分的准备时间。<br/>
      3. 活动场地应该要求当地办事处提前进行实地勘察。<br/>
    </div>
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins]
}
</script>

<style lang="stylus" scoped>
  .com-box {
    margin-top: 20px;
    .com-title-box {
      display: flex;
      justify-content: center;
      align-items: center;
      color: #FFFFFF;
      font-size: 15px;
      margin-bottom: 20px;
      img {
        width: 12px;
        height: 12px;
      }
      span {
        margin: 0 5px;
      }
    }
    .com-content {
      color: #fff;
      font-size: 10px;
      line-height: 20px;
      font-weight: 300;
      margin: 0 23px;
      padding: 16px;
      border: 1px solid #FFDEDE;
      border-radius: 8px;
      background: rgba(255, 181, 144, 0.4);
    }
  }
  .card
    box-sizing: border-box
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    // background: linear-gradient(#FF6B31 , #FF4A47);
    color #fff
    margin 15px
    &-title
      flex: none
      align-self: flex-start
      margin-bottom 10px
    &-content
      align-self: flex-start
      // margin 5px
      padding 5px
      line-height: 1.5
      border-radius: 8px
      background: rgba(255,184,146,0.5)
</style>